/* eslint-disable no-use-before-define */
import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { connect } from 'react-redux'
import { compose } from 'redux'
import { firestoreConnect } from 'react-redux-firebase'
import { checkSA, getCollection } from '../../constant'



class RolePicker extends Component {

  render() {
    const {profile, roles, label = 'Form', value = {}}= this.props
    let roleList = roles || [];
    if(checkSA(profile)){
      roleList = [{roleTitle : 'Admin'}]
    }
    return (
      <Autocomplete
        id="role"
        options={roleList}
        onChange={(event, newValue) => {
          if (newValue) {
            this.props.onChange(newValue.roleTitle);
          }
        }}
        getOptionLabel={(option) => option.roleTitle}
        renderInput={(params) => <TextField {...params} label={label} variant="standard" />}
        value={value}
      />
    );
  }

}

const mapStateToProps = (state) => {

  return {
    roles: state.firestore.ordered[getCollection(state.firebase.profile, 'roles')],
    profile: state.firebase.profile,
  }
}

export default compose(
  connect(mapStateToProps),
  firestoreConnect((props) => {
    return[
      { collection: getCollection(props.profile, 'roles'), orderBy: ['createdAt', 'desc'] },
    ]
  })
)(RolePicker)